// extracted by mini-css-extract-plugin
module.exports = {"highlights-card":"highlights-card_highlights-card__lZCeZ"};